let employeeTypes = [
  { value: "DEVELOPER", label: "Developer" },
  { value: "MANAGEMENT", label: "Management" },
  { value: "EMPLOYEE", label: "Employé" },
  { value: "CUSTOMER", label: "Customer" },
];

export default employeeTypes;
